import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Feather } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/auth", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    // Clear the hash so a refresh doesn't retry a used session_id
    window.history.replaceState({}, document.title, window.location.pathname);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data.token) localStorage.setItem("quill_token", data.token);
        await refresh();
        if (data.needs_onboarding) {
          nav("/onboarding", { replace: true });
        } else {
          nav("/dashboard", { replace: true });
        }
      } catch (err) {
        console.error("Auth callback failed", err);
        nav("/auth?error=google", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grain flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Feather className="w-8 h-8 text-[#D9B472] mx-auto mb-4 animate-pulse" />
        <p className="font-serif-display italic text-2xl text-[#F7F3EC]">Opening the ledger…</p>
        <p className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass mt-2">Signing you in with Google</p>
      </div>
    </div>
  );
}
